import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="aep-swift" api="track-action" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func track(action: String?, data: [String: Any]?)
`}</code></pre>
    <Variant platform="aep-objc" api="track-action" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)trackAction:(NSString * _Nullable)action data:(NSDictionary<NSString *, id> * _Nullable)data;
`}</code></pre>
    <Variant platform="acp-objc" api="track-action" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) trackAction: (nullable NSString*) action data: (nullable NSDictionary*) contextData;
`}</code></pre>
    <Variant platform="aep-swift" api="track-state" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func track(state: String?, data: [String: Any]?)
`}</code></pre>
    <Variant platform="aep-objc" api="track-state" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)trackState:(NSString * _Nullable)state data:(NSDictionary<NSString *, id> * _Nullable)data;
`}</code></pre>
    <Variant platform="acp-objc" api="track-state" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) trackState: (nullable NSString*) state data: (nullable NSDictionary*) contextData;
`}</code></pre>
    <Variant platform="aep-swift" api="collect-pii" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func collectPii(_ data: [String: Any])
`}</code></pre>
    <Variant platform="aep-objc" api="collect-pii" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)collectPii:(NSDictionary<NSString *, id> * _Nonnull)data;
`}</code></pre>
    <Variant platform="acp-objc" api="collect-pii" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) collectPii: (nonnull NSDictionary<NSString*, NSString*>*) data;
`}</code></pre>
    <Variant platform="aep-swift" api="collect-launch-info" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func collectLaunchInfo(_ userInfo: [String: Any])
`}</code></pre>
    <Variant platform="aep-objc" api="collect-launch-info" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)collectLaunchInfo:(NSDictionary<NSString *, id> * _Nonnull)userInfo;
`}</code></pre>
    <Variant platform="acp-objc" api="collect-launch-info" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) collectLaunchInfo: (nonnull NSDictionary*) userInfo;
`}</code></pre>
    <Variant platform="aep-swift" api="get-sdk-identities" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getSdkIdentities(completion: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <Variant platform="aep-objc" api="get-sdk-identities" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)getSdkIdentities:(void (^ _Nonnull)(NSString * _Nullable, NSError * _Nullable))completion;
`}</code></pre>
    <Variant platform="acp-objc" api="get-sdk-identities" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getSdkIdentities: (nullable void (^) (NSString* __nullable content)) callback;
+ (void) getSdkIdentitiesWithCompletionHandler: (nullable void (^) (NSString* __nullable content, NSError* _Nullable error)) completionHandler;
`}</code></pre>
    <Variant platform="aep-swift" api="set-log-level" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func setLogLevel(_ level: LogLevel)
`}</code></pre>
    <Variant platform="aep-objc" api="set-log-level" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)setLogLevel:(enum AEPLogLevel)level;
`}</code></pre>
    <Variant platform="acp-objc" api="set-log-level" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) setLogLevel: (ACPMobileLogLevel) logLevel;
`}</code></pre>
    <Variant platform="aep-swift" api="register-url-handler" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`  // Not supported
`}</code></pre>
    <Variant platform="aep-objc" api="register-url-handler" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`  // Not supported
`}</code></pre>
    <Variant platform="acp-objc" api="register-url-handler" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) registerURLHandler: (nonnull BOOL (^) (NSString* __nullable url)) callback;
`}</code></pre>
    <Variant platform="aep-swift" api="set-app-group" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func setAppGroup(_ group: String?)
`}</code></pre>
    <Variant platform="aep-objc" api="set-app-group" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)setAppGroup:(NSString * _Nullable)group;
`}</code></pre>
    <Variant platform="acp-objc" api="set-app-group" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) setAppGroup: (nullable NSString*) appGroup;
`}</code></pre>
    <Variant platform="aep-swift" api="configure-with-app-id" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func configureWith(appId: String)
`}</code></pre>
    <Variant platform="aep-objc" api="configure-with-app-id" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)configureWithAppId:(NSString * _Nonnull)appId;
`}</code></pre>
    <Variant platform="acp-objc" api="configure-with-app-id" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) configureWithAppId: (NSString* __nullable) appid;
`}</code></pre>
    <Variant platform="aep-swift" api="update-configuration" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func updateConfigurationWith(configDict: [String: Any])
`}</code></pre>
    <Variant platform="aep-objc" api="update-configuration" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)updateConfiguration:(NSDictionary<NSString *, id> * _Nonnull)configDict;
`}</code></pre>
    <Variant platform="acp-objc" api="update-configuration" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) updateConfiguration: (NSDictionary* __nullable) config;
`}</code></pre>
    <Variant platform="aep-swift" api="configure-with-file-in-path" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func configureWith(filePath: String)
`}</code></pre>
    <Variant platform="aep-objc" api="configure-with-file-in-path" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void)configureWithFilePath:(NSString * _Nonnull)filePath;
`}</code></pre>
    <Variant platform="acp-objc" api="configure-with-file-in-path" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) configureWithFileInPath: (NSString* __nullable) filepath;
`}</code></pre>
    <Variant platform="aep-swift" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static var extensionVersion: String
`}</code></pre>
    <Variant platform="aep-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="acp-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      